import React from 'react';
import '../../styles/industries.css';
import { motion } from 'framer-motion';

const CloudDevOps = () => (
  <motion.div className="industry-page" initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.8 }}>
    <div className="industry-content">
      <h1>Cloud & DevOps Services</h1>
      <p>Streamlining cloud operations with secure, efficient DevOps pipelines and automation.</p>
      <ul className="bullet-points">
        <li>☁️ AWS, Azure, GCP deployments. </li>
        <li>⚙️ CI/CD pipeline automation. </li>
        <li>🔐 Infra as Code. </li>
        <li>📊 Monitoring & Observability. </li>
      </ul>
    </div>
  </motion.div>
);

export default CloudDevOps;
